module.exports = __webpack_public_path__ + "img/down-arrow.3b2793ba.svg";